import tw from "twin.macro";
import { ChronoPieChart } from "@/routes/area-aggregate/components/aggregate/chart-donut";

function ProgressChrono({ progressPercent }: { progressPercent: number }) {
  return (
    <div
      css={[tw`m-[1px] w-[55px] shrink-0 rounded-xl bg-white rounded-l-none`]}
    >
      <div css={[tw`w-full h-full rounded-full`]}>
        <ChronoPieChart progressPercent={progressPercent} />
      </div>
    </div>
  );
}

export default ProgressChrono;
